import React from "react"

export const Coin = (props: React.SVGAttributes<SVGElement>): JSX.Element => (
	<svg {...props} width="100%" height="100%" viewBox="0 0 1140 1235" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2">
		<circle cx="569.796" cy="664.434" r="569.796" fill="rgb(255,187,51)" />
		<circle cx="569.796" cy="569.796" r="569.796" fill="rgb(255,225,77)" />
		<path
			d="M94.55,593.105C94.176,585.403 93.987,577.622 93.987,569.796C93.987,307.19 307.19,93.987 569.796,93.987C832.402,93.987 1045.61,307.19 1045.61,569.796C1045.61,577.622 1045.42,585.403 1045.04,593.104C1032.85,341.289 824.576,140.604 569.796,140.604C315.016,140.604 106.738,341.289 94.55,593.105Z"
			fill="rgb(230,138,46)"
		/>
		<path
			d="M94.534,593.43C106.523,341.496 314.884,140.604 569.796,140.604C824.708,140.604 1033.07,341.496 1045.06,593.43C1033.07,845.364 824.708,1046.26 569.796,1046.26C314.884,1046.26 106.523,845.364 94.534,593.43Z"
			fill="rgb(255,187,51)"
		/>
		<path
			d="M782.104,357.487C725.796,301.18 649.426,269.547 569.796,269.547C404.084,269.547 269.547,404.084 269.547,569.796C269.547,735.507 404.084,870.044 569.796,870.044C649.426,870.044 725.796,838.411 782.104,782.104L675.95,675.95C647.796,704.103 609.611,719.92 569.796,719.92C486.94,719.92 419.671,652.651 419.671,569.796C419.671,486.94 486.94,419.671 569.796,419.671C609.611,419.671 647.796,435.488 675.95,463.642L782.104,357.487Z"
			fill="rgb(255,225,77)"
		/>
	</svg>
)
